import aframe from 'aframe'
import 'aframe-animation-component'

import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import database from "./database"

import {Provider} from "react-redux"

import store from './store'

var arrayGP = navigator.getGamepads()
console.log(arrayGP)

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,

    document.getElementById('root')
);

registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js